export default "__VITE_ASSET__BlO0bmZb__"